export const calculatePercentage = (total, value) => {
  if (!total || !value) return 0;

  return Math.round((value / total) * 100);
};

